var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 37L37 26.5L26.5 16L22.825 19.675L27.025 23.875H16V29.125H27.025L22.825 33.325L26.5 37ZM26.5 52.75C22.8688 52.75 19.4563 52.0605 16.2625 50.6815C13.0688 49.3025 10.2906 47.4326 7.92813 45.0719C5.56563 42.7111 3.69575 39.933 2.3185 36.7375C0.941254 33.542 0.251753 30.1295 0.250003 26.5C0.248253 22.8705 0.937753 19.458 2.3185 16.2625C3.69925 13.067 5.56913 10.2889 7.92813 7.92813C10.2871 5.56738 13.0653 3.6975 16.2625 2.3185C19.4598 0.9395 22.8723 0.25 26.5 0.25C30.1278 0.25 33.5403 0.9395 36.7375 2.3185C39.9348 3.6975 42.7129 5.56738 45.0719 7.92813C47.4309 10.2889 49.3016 13.067 50.6841 16.2625C52.0666 19.458 52.7553 22.8705 52.75 26.5C52.7448 30.1295 52.0553 33.542 50.6815 36.7375C49.3078 39.933 47.4379 42.7111 45.0719 45.0719C42.7059 47.4326 39.9277 49.3034 36.7375 50.6841C33.5473 52.0649 30.1348 52.7535 26.5 52.75Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.56765fceb55fb7c07fc536185a20dcdb.svg";
export { ForwardRef as ReactComponent };